import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api'; // Adjust path based on location

// Thunks
export const createFollowUp = createAsyncThunk(
    'followup/create',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/followups', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to create follow-up');
        }
    }
);

export const getFollowUps = createAsyncThunk(
    'followup/getByPlot',
    async (plotId, { rejectWithValue }) => {
        try {
            const response = await api.get(`/followups/plot/${plotId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch follow-ups');
        }
    }
);

export const deleteFollowUp = createAsyncThunk(
    'followup/delete',
    async (id, { rejectWithValue }) => {
        try {
            await api.delete(`/followups/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to delete follow-up');
        }
    }
);

export const updateFollowUpStatus = createAsyncThunk(
    'followup/updateStatus',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await api.patch(`/followups/${id}/status`, { status });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to update status');
        }
    }
);

const followUpSlice = createSlice({
    name: 'followup',
    initialState: {
        followUps: [],
        loading: false,
        error: null,
        success: false
    },
    reducers: {
        clearFollowUpState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createFollowUp.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(createFollowUp.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.followUps.unshift(action.payload); // Add new item to start of list
            })
            .addCase(createFollowUp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Get
            .addCase(getFollowUps.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getFollowUps.fulfilled, (state, action) => {
                state.loading = false;
                state.followUps = action.payload;
            })
            .addCase(getFollowUps.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete
            .addCase(deleteFollowUp.fulfilled, (state, action) => {
                state.followUps = state.followUps.filter(f => f._id !== action.payload);
            })
            // Update Status
            .addCase(updateFollowUpStatus.fulfilled, (state, action) => {
                const index = state.followUps.findIndex(f => f._id === action.payload._id);
                if (index !== -1) {
                    state.followUps[index] = action.payload;
                }
            });
    }
});

export const { clearFollowUpState } = followUpSlice.actions;
export default followUpSlice.reducer;
